/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateCustomerPortalLinkRequestEntity = {
  /**
   * Unique identifier of the customer.
   */
  customerId: string;
};

/** @internal */
export const CreateCustomerPortalLinkRequestEntity$inboundSchema: z.ZodType<
  CreateCustomerPortalLinkRequestEntity,
  z.ZodTypeDef,
  unknown
> = z.object({
  customer_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "customer_id": "customerId",
  });
});
/** @internal */
export type CreateCustomerPortalLinkRequestEntity$Outbound = {
  customer_id: string;
};

/** @internal */
export const CreateCustomerPortalLinkRequestEntity$outboundSchema: z.ZodType<
  CreateCustomerPortalLinkRequestEntity$Outbound,
  z.ZodTypeDef,
  CreateCustomerPortalLinkRequestEntity
> = z.object({
  customerId: z.string(),
}).transform((v) => {
  return remap$(v, {
    customerId: "customer_id",
  });
});

export function createCustomerPortalLinkRequestEntityToJSON(
  createCustomerPortalLinkRequestEntity: CreateCustomerPortalLinkRequestEntity,
): string {
  return JSON.stringify(
    CreateCustomerPortalLinkRequestEntity$outboundSchema.parse(
      createCustomerPortalLinkRequestEntity,
    ),
  );
}
export function createCustomerPortalLinkRequestEntityFromJSON(
  jsonString: string,
): SafeParseResult<CreateCustomerPortalLinkRequestEntity, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      CreateCustomerPortalLinkRequestEntity$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateCustomerPortalLinkRequestEntity' from JSON`,
  );
}
